import {useSession} from "next-auth/react";
import {useEffect, useState} from "react";
import {userHasPermissions, userHasRoles} from "../routes/myLinks";

export const useAuth = () => {
    const {data: session, status} = useSession()
    const [user, setUser] = useState(()=>{
        if (status === 'authenticated'){
            return session.user
        }

        return {
            permissions: [],
            id: 1,
        }
    })

    useEffect(()=>{
        if (status === 'authenticated'){
            setUser(session.user)
        }
    }, [status])

    return {
        user,
        status,
        hashRoles: function (roles){
            if (this.user){
                return userHasRoles(roles, user.roles)
            }
            return false
        },
        hasPermissions: function (permissions){
            if (this.user){
                return userHasPermissions(permissions, user.permissions)
            }
            return false
        }
    }
}